import { UnitTransferEventTypeEnumType } from '__generated__/graphql';

import { TimelineStatus } from 'primitives/Timeline/VerticalTimeline';

/**
 * Every timeline row used to render as `success`, so a rejected transfer showed a green tick.
 * An event is something that already happened, so it is only ever success or failure — never
 * "pending", which is a property of the request, not of its history.
 */
const FAILURE_EVENT_TYPES: UnitTransferEventTypeEnumType[] = [
  UnitTransferEventTypeEnumType.TransfereeDeclined,
  UnitTransferEventTypeEnumType.EscrowExceptionDeclined,
  UnitTransferEventTypeEnumType.DocumentsMarkedIncomplete,
  UnitTransferEventTypeEnumType.SignatureDeclined,
  UnitTransferEventTypeEnumType.Rejected,
  UnitTransferEventTypeEnumType.Withdrawn,
];

export default function unitTransferEventTypeToTimelineStatus(
  type: UnitTransferEventTypeEnumType
): TimelineStatus {
  return FAILURE_EVENT_TYPES.includes(type) ? 'failure' : 'success';
}
